import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiTextField = {
  defaultProps: {
    InputLabelProps: {
      shrink: true
    },
    rows: 3
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      textarea: {
        cursor: "pointer"
      },
      maxWidth: "100%",
      ".MuiInputLabel-root, .MuiInputLabel-root.Mui-focused": {
        color: "inherit",
        position: "relative",
        transform: "none",
        "&.MuiInputLabel-outlined": {
          ...ownerState.size === "small" && {
            fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall
          },
          ...ownerState.size === "large" && {
            fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault
          }
        }
      },
      ".MuiInputLabel-root.Mui-error, .MuiInputLabel-root.Mui-disabled": {
        color: theme.palette.text.primary
      },
      ".MuiInputBase-multiline": {
        cursor: "pointer",
        maxWidth: "100%",
        width: "320px",
        height: "inherit",
        ...ownerState.size === "small" && {
          height: "inherit"
        },
        ...ownerState.size === "large" && {
          height: "inherit"
        },
        alignItems: "flex-start",
        ".MuiInputAdornment-root": {
          maxHeight: "100%",
          height: "100%"
        }
      },
      ".MuiInputAdornment-root": {
        color: theme.palette.text.secondary,
        button: {
          color: "inherit"
        }
      },
      'input[type="number"]': {
        MozAppearance: "textfield",
        "&:hover, &:focus": {
          MozAppearance: "initial"
        }
      },
      ".Mui-readOnly": {
        color: theme.palette.text.disabled,
        background: theme.palette.action.hover,
        ".MuiInputBase-multiline": {
          padding: theme.spacing(2)
        }
      }
    })
  },
  variants: [
    {
      props: { naked: true, multiline: true, variant: "outlined" },
      style: ({ theme }) => {
        var _a, _b, _c, _d;
        return {
          fieldset: {
            borderLeftColor: (_a = theme.palette.outline) != null ? _a : theme.palette.divider,
            borderTopColor: "transparent",
            borderRightColor: "transparent",
            borderBottomColor: "transparent",
            borderRadius: 0
          },
          // Display all borders for naked TextArea with icon
          ".MuiInputBase-adornedEnd .MuiOutlinedInput-notchedOutline": {
            borderTopColor: (_b = theme.palette.outline) != null ? _b : theme.palette.divider,
            borderRightColor: (_c = theme.palette.outline) != null ? _c : theme.palette.divider,
            borderBottomColor: (_d = theme.palette.outline) != null ? _d : theme.palette.divider,
            borderRadius: capitalDesignTokens.foundations.units.unitHalf
          }
        };
      }
    }
  ]
};
export {
  MuiTextField
};
//# sourceMappingURL=MuiTextField.js.map
